module.exports = {"130535100":"临西镇","130535101":"河西镇","130535102":"下堡寺镇","130535103":"尖冢镇","130535104":"老官寨镇","130535105":"吕寨镇","130535200":"东枣园乡","130535203":"摇鞍镇乡","130535204":"大刘庄乡","130535400":"轴承工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130535.json
// module id = 148
// module chunks = 0